import React from 'react';
import Helmet from 'react-helmet';
import LocationList from '../../Components/LocationList/LocationList';
import { AppContext } from '../../Context/AppContext';

function RouteLocationsList() {
  return (
    <AppContext.Consumer>
      {({ locations }) => (
        <React.Fragment>
          <Helmet>
            <title>
              Fish Toronto | Locations
            </title>
          </Helmet>
          <LocationList arr={locations} />
        </React.Fragment>
      )
    }
    </AppContext.Consumer>
  );
}

export default RouteLocationsList;



// WEBPACK FOOTER //
// ./src/Routes/RouteLocationsList/index.jsx